import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { Option } from '@/common/types';
import { API_URL } from '@/dtos';

interface PaymentRuleAccountMap {
  [key: string]: string;
}
export const QUERY_KEY = 'GET_PAYMENT_RULE_ACCOUNTS';

export default (visible: boolean, payoutDefinitionId: string) => {
  const { data, isLoading, isSuccess } = useQuery(
    [QUERY_KEY, payoutDefinitionId],
    () => api.get(API_URL.PAYOUT_DEFINITIONS_PLANS_BY_ID(payoutDefinitionId)),
    {
      enabled: visible && !!payoutDefinitionId,
    }
  );

  const fieldOptions = useMemo(() => {
    const list = data?.data || [];
    return list.map((item) => {
      const formatedItem: Option = {
        key: `${item.id || ''}`,
        value: item.name,
        name: item.name,
      };
      return formatedItem;
    });
  }, [data]);
  const fieldsMap = useMemo(() => {
    const fieldMap: PaymentRuleAccountMap = {};
    fieldOptions.forEach((item) => {
      fieldMap[`${item.key}`] = `${item.value}`;
    });
    return fieldMap;
  }, [fieldOptions]);
  return {
    isLoading,
    isSuccess,
    fieldOptions,
    fieldsMap,
  };
};
